import type {
  GetSupplierRegistTemplateMetaList,
  GetAnswerTransitionsResponse,
  GetAnswerTransitions,
  GetSubmittedAnswersResponse,
  GetSubmittedAnswers,
  GetTableauWorkbookUrlResponse,
  GetTableauWorkbookUrl,
} from '@/types/api/customer/SupplierRegistTemplate'
import type { SupplierRegistTemplateMeta } from '@/types/domain/SupplierRegistTemplate'

import { useApiForCustomer } from '@/composables/useApi'

/**
 * バイヤーが依頼しているサプライヤー登録テンプレートの一覧を取得
 */
export const getSupplierRegistTemplateMetaList: GetSupplierRegistTemplateMetaList
  = params =>
    useApiForCustomer<SupplierRegistTemplateMeta[]>(
      '/rest/supplier-regist-templates/list',
      {
        method: 'GET',
        query: params,
        onResponse(context) {
          if (context.response._data.supplierRegistTemplates) {
            context.response._data
              = context.response._data.supplierRegistTemplates
          }
        },
      },
    )

/**
 * バイヤーが依頼している公開設定のサプライヤー登録テンプレートの一覧を取得
 */
export const getPublicSupplierRegistTemplateMetaList: GetSupplierRegistTemplateMetaList
  = () =>
    useApiForCustomer<SupplierRegistTemplateMeta[]>(
      '/rest/supplier-regist-templates/buyer-improvement-plans',
      {
        method: 'GET',
        onResponse(context) {
          if (context.response._data.supplierRegistTemplates) {
            context.response._data
              = context.response._data.supplierRegistTemplates
          }
        },
      },
    )

/**
 * バイヤーが依頼しているサプライヤー登録テンプレートの回答状況を取得
 */
export const getAnswerTransitions: GetAnswerTransitions = (
  supplierRegistTemplateId: string,
) =>
  useApiForCustomer<GetAnswerTransitionsResponse>(
    `/rest/supplier-regist-templates/${supplierRegistTemplateId}/answer-summary`,
    {
      method: 'GET',
      onResponse(context) {
        if (context.response._data.answerTransition) {
          context.response._data.answerTransitions
            = context.response._data.answerTransition
          delete context.response._data.answerTransition
        }
      },
    },
  )

/**
 * バイヤーが依頼しているサプライヤー登録テンプレートの提出済みの回答を取得
 */
export const getSubmittedAnswers: GetSubmittedAnswers = (
  supplierRegistTemplateId: string,
) =>
  useApiForCustomer<GetSubmittedAnswersResponse>(
    `/rest/supplier-regist-templates/${supplierRegistTemplateId}/submitted-answers`,
    {
      method: 'GET',
    },
  )

/**
 * Tableau のワークブックの URL を取得
 */
export const getTableauWorkbookUrl: GetTableauWorkbookUrl = ({
  supplierRegistTemplateId,
}) =>
  useApiForCustomer<GetTableauWorkbookUrlResponse>(
    `/rest/supplier-regist-templates/${supplierRegistTemplateId}/tableau`,
    {
      method: 'GET',
    },
  )
